// LOCATION: admin-portal/src/pages/Login.jsx

import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // ✅ Toggle State
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // 1. Authenticate
      const result = await signInWithEmailAndPassword(auth, email, password);
      
      // 2. Check Permission
      await checkAdminAccess(result.user);
    } catch (err) {
      console.error("Login Error:", err);
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        setError("Invalid email or password.");
      } else {
        setError("Login Failed: " + err.message);
      }
      setLoading(false);
    }
  };

  const checkAdminAccess = async (user) => {
    try {
      const docRef = doc(db, 'admin_access', user.email);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const permissions = docSnap.data().permissions || {};
        // Route based on permission
        if (permissions.super_admin || permissions.user_management) navigate('/users');
        else if (permissions.events) navigate('/events');
        else if (permissions.subscribers) navigate('/subscribers');
        else navigate('/access');
      } else {
        setError("Access Denied: You are not authorized as an admin.");
        await auth.signOut();
        setLoading(false);
      }
    } catch (err) {
      setError("Permission Check Failed: " + err.message);
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">Ccuring Admin</h1>
        <p className="login-subtitle">Secure Portal Login</p>

        {error && <div className="error-banner">{error}</div>}

        <form onSubmit={handleEmailLogin}>
          <div className="input-group">
            <label>Email</label>
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              placeholder="admin@ccuring.com"
              required
            />
          </div>
          
          <div className="input-group">
            <label>Password</label>
            <div className="password-wrapper">
              <input 
                type={showPassword ? "text" : "password"} // ✅ Dynamic Type
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                placeholder="••••••"
                required
              />
              <button 
                type="button" 
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "🙈" : "👁️"} 
              </button>
            </div>
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Verifying..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;